import React from 'react';
import { AwardIcon } from 'lucide-react';
import { ServicePage } from '../components/ServicePage';
import { company, services } from '../data/site';
const service = services.find(s => s.key === 'ramonage')!;
export function Ramonage() {
  return <ServicePage service={service} note="Le débistrage est obligatoire avant tout tubage ou gainage dans un conduit de fumée : il est imposé par les assurances." data-id="element-308" data-mp="2urm78j89y9f2">
      <div className="mt-8 rounded-2xl bg-navy-800 p-6 sm:p-8" data-id="element-309" data-mp="34mxkex41b8kp">
        <AwardIcon className="h-8 w-8 text-ember-300" aria-hidden="true" data-id="element-310" data-mp="2zpxeqnb3k7u4" />
        <h2 className="mt-4 font-display text-xl font-extrabold text-white sm:text-2xl" data-id="element-311" data-mp="3dp6tdijnmtvz">
          Un travail conforme à la réglementation
        </h2>
        <p className="mt-4 text-[1.02rem] leading-relaxed text-navy-100" data-id="element-312" data-mp="38rdnkqm9k1w8">
          {company.ramoneurNote}
        </p>
        <p className="mt-4 text-[0.97rem] leading-relaxed text-navy-200" data-id="element-313" data-mp="1jbe8ytzvlk97">
          Ramoneur-Fumiste diplômé du COSTIC — qualification exigée par les
          assurances en cas de sinistre, selon la loi 96-603 Raffarin du 5 juillet
          1996.
        </p>
      </div>
    </ServicePage>;
}